import { Card } from "@mui/material";

const LayoutCard = ({ children, ...res }) => {
  return (
    <Card
      sx={{ display: "flex", flexDirection: "column", flex: 1, padding: 3, overflow: "auto" }}
      {...res}
    >
      {children}
    </Card>
  );
};

export default LayoutCard;
